interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc: string;
  actionLabel?: string;
  actionHref?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  actionLabel,
  actionHref,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-background-300/70 pb-6 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2">
          <span className="h-4 w-1 rounded-full bg-primary-500"></span>
          <span className="font-label text-xs tracking-[0.28em] text-primary-600">{eyebrow}</span>
        </div>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>
      </div>
      {actionLabel && actionHref ? (
        <a
          href={actionHref}
          className="group inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-full border border-secondary-300 bg-background-50 px-4 py-2 text-sm text-secondary-900 transition-colors hover:border-secondary-500 hover:bg-secondary-100"
        >
          {actionLabel}
          <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </a>
      ) : null}
    </div>
  );
}